<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div>
      <svg-icon class-name="international-icon" icon-class="language" />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="lang in languages" :key="lang.code" :command="lang.code">
        {{ lang.description }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import SvgIcon from '@/components/SvgIcon';

export default {
  components: {
    SvgIcon
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    languages() {
      return [
        {
          code: 'en',
          description: 'English'
        },
        {
          code: 'fr',
          description: 'Français'
        },
        {
          code: 'nl',
          description: 'Nederlands'
        }
      ];
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch('setLanguage', lang);
    }
  }
};
</script>

<style scoped>
.international-icon {
  font-size: 20px;
  cursor: pointer;
  vertical-align: -5px !important;
}
</style>
